.stats {
  margin-bottom: 16px;
}

.filters {
  margin-bottom: 16px;
}

.filterLabel {
  margin-bottom: 4px;
  color: var(--ant-color-text-secondary);
}

.filterActions {
  display: flex;
  align-items: flex-end;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.userInfo {
  display: flex;
  gap: 16px;
  align-items: center;
}

.userDetails {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}
